import React from "react";
import LicenseDropzone from "./LicenseDropzone.jsx";
import { formatBytes } from "./licenseUtils.js";

/**
 * One license category: header, uploaded documents, and an upload dropzone.
 * The N/A checkbox only renders for optOut types when `onNaChange` is passed
 * (the onboarding step collects those answers; settings does not).
 */
function LicenseTypeCard({
  licenseType: t,
  docs = [],
  uploading,
  onFile,
  isNA = false,
  onNaChange,
  missing = false,
}) {
  const showNaToggle = t.optOut && !docs.length && !!onNaChange;

  return (
    <div className="rounded border border-slate-200 dark:border-slate-700 p-4 space-y-3">
      <div className="flex items-start justify-between gap-3">
        <div>
          <div className="flex items-center gap-2">
            <h3 className="text-sm font-semibold text-slate-800 dark:text-slate-100">
              {t.label}
            </h3>
            {t.required ? (
              <span className="text-[10px] uppercase font-semibold tracking-wide text-red-600 dark:text-red-400">
                Required
              </span>
            ) : (
              <span className="text-[10px] uppercase font-semibold tracking-wide text-slate-400">
                Optional
              </span>
            )}
            {missing && (
              <span className="text-[10px] uppercase font-semibold tracking-wide text-amber-600 dark:text-amber-400">
                · Missing
              </span>
            )}
          </div>
          {t.description && (
            <p className="text-xs text-slate-500 dark:text-slate-400 mt-1">
              {t.description}
            </p>
          )}
        </div>
      </div>

      {showNaToggle && (
        <label className="inline-flex items-center gap-2 text-xs text-slate-600 dark:text-slate-300 cursor-pointer">
          <input
            type="checkbox"
            checked={isNA}
            onChange={(e) => onNaChange(e.target.checked)}
          />
          <span>{t.naLabel}</span>
        </label>
      )}

      {docs.length > 0 && (
        <ul className="text-xs space-y-1">
          {docs.map((d) => (
            <li
              key={d.id}
              className="flex items-center gap-2 text-slate-600 dark:text-slate-300"
            >
              <span className="text-emerald-500">✓</span>
              <span className="font-medium">{d.original_name}</span>
              <span className="text-slate-400">({formatBytes(d.size)})</span>
            </li>
          ))}
        </ul>
      )}

      {!(t.optOut && isNA) && (
        <LicenseDropzone
          label={t.label}
          uploading={uploading}
          hasDocs={docs.length > 0}
          onFile={onFile}
        />
      )}
    </div>
  );
}

export default LicenseTypeCard;
